import classNames from "classnames"
import React, { CSSProperties, ReactNode } from "react"
import * as styles from "./Button.module.css"
import { Link } from "gatsby"

type ButtonProps = {
  children: ReactNode
  onClick?: () => void
  fill?: boolean
  underline?: boolean
  disabled?: boolean
  link?: string
  leftResponsive?: boolean
  rightResponsive?: boolean
  center?: boolean
  style?: CSSProperties
}

const Button = ({
  children,
  onClick,
  fill = false,
  underline = false,
  disabled = false,
  link = "#",
  leftResponsive,
  rightResponsive,
  center,
  style = {},
}: ButtonProps) => {
  return (
    <Link
      to={link}
      className={classNames(styles.buttonLink, {
        [styles.left]: leftResponsive,
        [styles.right]: rightResponsive,
        [styles.center]: center,
      })}
    >
      <button
        onClick={onClick}
        disabled={disabled}
        className={classNames(styles.button, {
          [styles.fill]: fill,
          [styles.underline]: underline,
        })}
        style={style}
      >
        {children}
      </button>
    </Link>
  )
}

export default Button
